module.exports = __webpack_public_path__ + "static/media/btn_android_ita.29b58b9e.png";